import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-50">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                  <i className="ri-camera-lens-line text-xl text-background-50"></i>
                </div>
                <span className="text-lg font-heading">黄油下载</span>
              </div>
              <p className="text-sm text-background-400 leading-relaxed">
                黄油相机官方安全下载平台，提供最新版黄油相机App下载，支持iOS与Android设备。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold mb-4 text-background-100">文章分类</h4>
              <ul className="space-y-2.5">
                {categories.slice(0, 4).map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-background-400 hover:text-background-100 transition-colors duration-200 cursor-pointer"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold mb-4 text-background-100">快速链接</h4>
              <ul className="space-y-2.5">
                <li>
                  <Link to="/" className="text-sm text-background-400 hover:text-background-100 transition-colors duration-200 cursor-pointer">
                    首页
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="text-sm text-background-400 hover:text-background-100 transition-colors duration-200 cursor-pointer">
                    关于我们
                  </Link>
                </li>
                <li>
                  <a href="#download" className="text-sm text-background-400 hover:text-background-100 transition-colors duration-200 cursor-pointer">
                    下载黄油相机
                  </a>
                </li>
                <li>
                  <Link to="/category/shiyong-jiaocheng" className="text-sm text-background-400 hover:text-background-100 transition-colors duration-200 cursor-pointer">
                    使用教程
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold mb-4 text-background-100">免责声明</h4>
              <p className="text-sm text-background-400 leading-relaxed">
                本站为黄油相机爱好者建立的第三方资源分享平台，非黄油相机官方运营。黄油相机版权归北京缪客科技有限公司所有。本站提供的下载链接均来自官方渠道。
              </p>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-sm text-background-500">
              &copy; {new Date().getFullYear()} 黄油下载 jiruida.cn - 保留所有权利
            </p>
            <div className="flex items-center gap-4">
              <Link to="/about" className="text-sm text-background-500 hover:text-background-300 transition-colors duration-200 cursor-pointer">
                联系我们
              </Link>
              <span className="text-background-700">|</span>
              <Link to="/about" className="text-sm text-background-500 hover:text-background-300 transition-colors duration-200 cursor-pointer">
                关于我们
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}